<div class="dialog-area" style="overflow: hidden;">
  <div mat-dialog-title class="modal-title">
    <h1>{{'Detalhes CAR' | translate}}</h1>
    <a (click)="onNoClick()">X</a>
  </div>
  <div class="divider">
  </div>
  <div mat-dialog-content class="content">
    <div class="pb-3">
      <div class="d-flex flex-column gap-3 pb-3">
        <span><b>{{'Código' | translate}}:</b> {{notaFiscal?.id}}</span>
        <span><b>{{'Número Nota' | translate}}:</b> {{notaFiscal?.numeroNota}}</span>
        <span><b>{{'Data' | translate}}: </b>{{notaFiscal?.timestamp | date:'dd/MM/YYYY'}}</span>
        <span><b>{{'Status' | translate}}: </b> {{notaFiscal?.status}}</span>
        <span><b>{{'Quantidade' | translate}}:</b> {{(notaFiscal?.quantidade ? notaFiscal?.quantidade : '0') | currency:'':'':'1.0-8'}}</span>
        <div class="d-flex flex-column">
          @for (img of notaFiscal?.imagens; track img) {
            <div>
              <div>
                <b>{{ img?.descricao }}: </b>
                <a (click)="openFile(img.imagem!, img.imagemContentType)" style="cursor: pointer;">
                  @if (img.imagemContentType?.includes('image')) {
                    <img [src]="'data:' + img.imagemContentType + ';base64,' + img.imagem" style="max-width: 200px" alt="notaFiscal image" />
                  }
                </a>
                @if (img.imagemContentType?.includes('pdf')) {
                  <a (click)="openFile(img.imagem!, img.imagemContentType)" style="cursor: pointer;">
                    Clique para abrir o documento PDF
                  </a>
                }
                @if (img.imagemContentType?.includes('kml')) {
                  <a (click)="openFileKML(img.imagem!, img.imagemContentType)" style="cursor: pointer;">
                    {{'Clique para baixar o arquivo KML' | translate}}
                  </a>
                }
              </div>
            </div>
          }
        </div>
        <span><b>{{'Usuário' | translate}}:</b> {{notaFiscal?.user?.firstName | titlecase}} {{notaFiscal?.user?.lastName | titlecase}}</span>
        <span><b>{{'Observação' | translate}}:</b> {{notaFiscal?.observacao}}</span>
        <span><b>{{'Entidade' | translate}}:</b> {{notaFiscal?.entidade?.descricao}}</span>
        <span><b>{{'Tipo Documento' | translate}}:</b>{{notaFiscal?.tipoDocumento?.descricao}}</span>
        <span><b>{{'Descrição Configuração' | translate}}:</b> {{notaFiscal?.descricaoConfig}}</span>
        <span><b>{{'Área Consolidada' | translate}}:</b> {{notaFiscal?.areaCar | currency:'':'':'1.0-8'}}</span>
        <span><b>{{'Área Preservação' | translate}}:</b> {{notaFiscal?.areaPreservacao | currency:'':'':'1.0-8'}}</span>
        <span><b>{{'Exercicio' | translate}}:</b> {{notaFiscal?.exercicio}}</span>
        <span><b>{{'Mapa da Área' | translate}}:</b> {{notaFiscal?.latitude}}</span>
        <span><b>{{'Imagem Mapa' | translate}}:</b> <img [src]="'data:' + notaFiscal?.imagemMapaContentType + ';base64,' + notaFiscal?.imagemMapa" class="img-fluid ps-2"> </span>
        <!-- <mat-form-field class="w-75">
        <mat-label>Data da Renovação</mat-label>
        <input matInput [matDatepicker]="dp" [(ngModel)]="dataRenovacao" disabled>
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="dp"></mat-datepicker-toggle>
        <mat-datepicker #dp disabled="false"></mat-datepicker>
      </mat-form-field> -->
    </div>

    <div class="divider"></div>
    <div class="buttons pt-4">
      <button type="button" class="btn btn-outline-success" (click)="onNoClick()">{{'Fechar' | translate}}</button>
      <!-- <button type="button" class="btn btn-success" (click)="renovar(notaFiscal)">{{'Renovar' | translate}}</button> -->
    </div>
  </div>
</div>
